import React from 'react';

import { Row } from '@opendoor/atoms/box';
import { cn } from '@opendoor/atoms/utils';

interface DividerProps {
  className?: string;
}

/**
 * Divider component for separating content into clear groups.
 *
 * A simple horizontal rule that defaults to full width. Carries no spacing of
 * its own — wrap it in a padded container when you need room around it.
 *
 * Atoms has no `hr` element (`as` accepts only the semantic container
 * elements), so the separator role is expressed with ARIA, matching cake's
 * `shared/components/Divider`.
 *
 * @example
 * ```tsx
 * <Divider />
 * <Divider className="w-1/2" />
 * <Divider className="border-od-border-primary" />
 * ```
 */
export const Divider: React.FC<DividerProps> = ({ className }) => {
  return (
    <Row
      role="separator"
      aria-orientation="horizontal"
      className={cn('w-full border-t border-od-border-secondary', className)}
    />
  );
};
